import moment from "moment";
import { isNil, isEmpty } from "lodash";

export const PAYROLL_FREQUENCIES = {
  TWICE_PER_MONTH: "TWICE_PER_MONTH",
  WEEKLY: "WEEKLY",
  EVERY_OTHER_WEEK: "EVERY_OTHER_WEEK",
  MONTHLY: "MONTHLY",
};

// TODO use moment to calculate how many periods remain given current date and frequency
export function calcPayPeriodsPerYear(frequency: string) {
  switch (frequency) {
    case PAYROLL_FREQUENCIES.TWICE_PER_MONTH:
      return 24;
    case PAYROLL_FREQUENCIES.WEEKLY:
      return 52;
    case PAYROLL_FREQUENCIES.EVERY_OTHER_WEEK:
      return 26;
    case PAYROLL_FREQUENCIES.MONTHLY:
      return 12;

    default:
      throw new Error("No matching frequency found");
  }
}

export const DAILY = "DAILY";
export const MONTHLY = "MONTHLY";
export const PER_PAY_PERIOD = "PER_PAY_PERIOD";
export const END_OF_MONTH = "End of Month";

export const payrollPeriodsToEnglishMapping = {
  [PAYROLL_FREQUENCIES.TWICE_PER_MONTH]: "Twice a Month",
  [PAYROLL_FREQUENCIES.WEEKLY]: "Every Week",
  [PAYROLL_FREQUENCIES.EVERY_OTHER_WEEK]: "Every Two Weeks",
  [PAYROLL_FREQUENCIES.MONTHLY]: "Every Month",
};

const daysOfMonth = Array.from({ length: 31 }, (_, i) => i + 1);
export const daysOfMonthOptions = [
  ...daysOfMonth.map((d) => {
    return {
      key: d,
      value: d,
    };
  }),
  {
    key: 32,
    value: END_OF_MONTH,
  },
];

export function createDateFilterRange(daysBeforeNow: number) {
  const endDate = moment().endOf("day");
  const startDate = moment().subtract(daysBeforeNow, "days").startOf("day");
  return {
    startDate: startDate.toDate(),
    endDate: endDate.toDate(),
  };
}

interface ScheduleValues {
  payrollFrequency?: string | null;
  dayOne?: unknown;
  dayTwo?: unknown;
  anchorPayDate?: unknown;
}

export function hasMinimumScheduleValues(values: ScheduleValues) {
  if (isNil(values.payrollFrequency)) {
    return false;
  }

  if (values.payrollFrequency === PAYROLL_FREQUENCIES.TWICE_PER_MONTH) {
    return (
      !isNil(values.dayOne) &&
      !isNil(values.dayTwo) &&
      !isNil(values.anchorPayDate)
    );
  } else if (values.payrollFrequency === PAYROLL_FREQUENCIES.MONTHLY) {
    return !isNil(values.dayOne) && !isNil(values.anchorPayDate);
  } else if (
    values.payrollFrequency === PAYROLL_FREQUENCIES.WEEKLY ||
    values.payrollFrequency === PAYROLL_FREQUENCIES.EVERY_OTHER_WEEK
  ) {
    return !isNil(values.anchorPayDate);
  }
  return false;
}
export function parseDayString(day: number | string | null | undefined) {
  // Check number type first because `isEmpty` will return true for numbers (lol)
  if (typeof day === "number") {
    return day;
  } else if (isEmpty(day)) {
    return null;
  }
  return day === END_OF_MONTH ? 31 : parseInt(day as string);
}

export function formatDate(date: moment.MomentInput, format = "YYYY-MM-DD") {
  if (isNil(date)) {
    return null;
  }
  return moment(date).format(format);
}
